import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchableInnerWrapper, SearchableInput, SearchableWrapper, } from './BKJSelectSearch.styled.js';
import { useCallback, useEffect, useRef, useState } from 'react';
import { BKJIcon } from '../BKJIcon/index.js';
export const BKJSelectSearch = ({ placeholder, name, value, onChange, debounceMs, ...rest }) => {
    const debounceTimerRef = useRef(null);
    const [displayValue, setDisplayValue] = useState(value);
    useEffect(() => {
        setDisplayValue(value);
    }, [value]);
    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);
    const handleChange = useCallback((e) => {
        const newValue = e.target.value;
        setDisplayValue(newValue);
        if (debounceMs && debounceMs > 0) {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            debounceTimerRef.current = window.setTimeout(() => {
                onChange(e);
            }, debounceMs);
        }
        else {
            onChange(e);
        }
    }, [onChange, debounceMs]);
    return (_jsx(SearchableWrapper, { children: _jsxs(SearchableInnerWrapper, { children: [_jsx(BKJIcon, { iconName: "Search", fontSize: 18 }), _jsx(SearchableInput, { name: name, onChange: handleChange, value: displayValue, placeholder: placeholder, ...rest })] }) }));
};
//# sourceMappingURL=BKJSelectSearch.js.map